module.exports = __webpack_public_path__ + "img/gc_country_flag_de.9dd74711.svg";